<p-toast></p-toast>
<div class="app-verification-container">
    <!-- <p-card styleClass="p-card-shadow"> -->
        <h5 class="mt-0">{{'WORK_FLOW_ALL_STATUS'| translate}}</h5>
        <div class="card">
            <p-table #workFlowAllStatusTable [value]="workFlowAllStatusModel" [rows]="10" [paginator]="true"
                responsiveLayout="scroll" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [loading]="loading" sortField="ActionDate" [sortOrder]="1">
                <ng-template pTemplate="caption">
                    <!-- <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">Work Flow All Status</h5>
                    </div> -->
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="appID">{{'APP_ID'| translate}}
                        </th>
                        <th pSortableColumn="ProgramID">{{'PROGRAM'| translate}}
                        </th>
                        <th pSortableColumn="Action">{{'ACTION'| translate}}
                        </th>
                        <th pSortableColumn="ComponentName">{{'MI_SYSTEM'| translate}}
                        </th>
                        <th pSortableColumn="UserID">{{'USER_ID'| translate}}
                        </th>
                        <th pSortableColumn="LevelID">{{'LEVEL_ID'| translate}}
                        </th>
                        <th pSortableColumn="TragetDays">{{'TRAGET_DAYS'| translate}}
                        </th>
                        <th pSortableColumn="AssignDate">{{'ASSIGN_DATE'| translate}}
                        </th>
                        <th pSortableColumn="PendingCompletedDays">{{'PENDING_COMPLETED'| translate}}
                        </th>
                        <th pSortableColumn="Status">{{'STATUS'| translate}}
                        </th>
                        <th pSortableColumn="Remarks">{{'REMARKS'| translate}}
                        </th>
                        <th pSortableColumn="ActionDate">{{'ACTION_DATE'| translate}}
                        </th>
                        <th pSortableColumn="NextUser">{{'NEXT_USER'| translate}}
                        </th>
                        <th pSortableColumn="NextUser">{{'ACTIVE_STATUS'| translate}}
                        </th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>{{product.AppID}}</td>
                        <td>{{product.ProgramID}}</td>
                        <td *ngIf="!product?.NextUser.includes('CAO')">{{product.Action}}</td>
                        <td *ngIf="product?.NextUser.includes('CAO')"><a class="clickable-text"
                                (click)="onClickSubsidyDisbursment(product)">{{product.Action}}</a></td>
                        <td>{{product.ComponentName}}</td>
                        <td>{{product.UserID}}</td>
                        <td>{{product.LevelID}}</td>
                        <td>{{product.TragetDays}}</td>
                        <td>{{product.AssignDate | date : 'dd/MM/yyyy'}}</td>
                        <td>{{product.PendingCompletedDays}}</td>
                        <td>{{product.Status}}</td>
                        <td>{{product.Remarks}}</td>
                        <td>{{product.ActionDate | date : 'dd/MM/yyyy'}}</td>
                        <td>{{product.NextUser}}</td>
                        <td>{{product.ActiveStatus == 0 ? 'Inactive' : product.ActiveStatus == 1 ? 'Active' : ''}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{workFlowAllStatusModel ? workFlowAllStatusModel.length : 0
                        }} {{'STATUS_ADDED' | translate}}.
                    </div>
                </ng-template>
            </p-table>
        </div>
    <!-- </p-card> -->
</div>


<p-dialog header="{{'SUBSIDY_DISBURSMENT_DETAILS'| translate}}" [(visible)]="showSubsidyDisbursmentDialogBox"
    [modal]="true" [style]="{width: '80%',height:'40%'}" [maximizable]="true" [draggable]="false" [resizable]="false"
    (onHide)="onCloseDialog()">


    <div class="card subsidy-disbursment-details">
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-4">
                <label>{{'REMITTER_NAME'| translate}}</label>
                <p><label>{{ challanPaymentDetails?.RemitterName }}</label>
            </div>
            <div class="field col-12 md:col-4">
                <label>{{'CREDIT_DATE_TIME'| translate}}</label>
                <p><label>{{ challanPaymentDetails?.CreditDateTime | date:'medium'}}</label>
            </div>
            <div class="field col-12 md:col-4">
                <label>{{'FROM_ACCOUNT_NO'| translate}}</label>
                <p><label>{{ challanPaymentDetails?.FromAccountNumber }}</label>
            </div>
            <div class="field col-12 md:col-4">
                <label>{{'UTR'| translate}}</label>
                <p><label>{{ challanPaymentDetails?.UTR }}</label>
            </div>
            <div class="field col-12 md:col-4">
                <label>{{'DEPOSIT_AMOUNT'| translate}}</label>
                <p><label>{{ challanPaymentDetails?.Deposit_Amount }}</label>
            </div>
            <div class="field col-12 md:col-3">
                <label>{{'REFERENCE_ID'| translate}}</label>
                <p><label>{{ challanPaymentDetails?.ReferenceID }}</label>
            </div>
        </div>
    </div>
    <!-- </div> -->
</p-dialog>